import { useCallback } from "react";
import { useLocation } from "wouter";

export function useSmoothScroll() {
  const [, setLocation] = useLocation();

  const scrollTo = useCallback((target: string) => {
    const element = target.startsWith("#") ? document.getElementById(target.slice(1)) : document.querySelector(target);
    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      });
    } else if (target.startsWith("#")) {
      // Section doesn't exist on current page — navigate to homepage then scroll.
      setLocation(`/${window.location.search}${target}`);
    }
  }, [setLocation]);

  return scrollTo;
}
